import WarningsCallout from "./WarningsCallout";

export default function AssistantMessage({ message }) {
  if (message.role === "system" || message.role === "tool") {
    return null;
  }

  if (message.role === "user") {
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] rounded-2xl bg-main-purple px-4 py-3 text-sm text-white shadow-sm">
          <p className="whitespace-pre-wrap">{message.content}</p>
        </div>
      </div>
    );
  }

  if (message.error) {
    return (
      <div className="flex justify-start">
        <div className="max-w-[94%] rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          <p className="whitespace-pre-wrap">{message.content}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start">
      <div className="max-w-[94%] rounded-2xl border border-gray-200 bg-slate-50 px-4 py-4 text-sm text-gray-800">
        <p className="whitespace-pre-wrap leading-6">{message.content}</p>
        <WarningsCallout warnings={message.warnings} />
      </div>
    </div>
  );
}
